import type { ReactNode } from "react";

import { Box } from "@similarweb/ui-components/foundations";

import { AI_AGENT_PAGE_WIDTH } from "app/pages/sales-intelligence/pages/ai-agent/constants";

import { StyledFadeBlock } from "./styles";

const AIAgentChatFooter = ({ gradientToTop, children }: { gradientToTop?: boolean; children: ReactNode }) => {
    return (
        <Box
            position="absolute"
            bottom="30px"
            width={`${AI_AGENT_PAGE_WIDTH}px`}
            margin="18px 0"
        >
            <StyledFadeBlock gradientToTop={gradientToTop} />
            {children}
        </Box>
    );
};

export default AIAgentChatFooter;
